import { render, staticRenderFns } from "./publishInfo.vue?vue&type=template&id=4603e710&scoped=true"
import script from "./publishInfo.vue?vue&type=script&lang=js"
export * from "./publishInfo.vue?vue&type=script&lang=js"
import style0 from "./publishInfo.vue?vue&type=style&index=0&id=4603e710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603e710",
  null
  
)

export default component.exports